import { render } from "./HasVideoEmbedIndicator.vue?vue&type=template&id=1dd90b14&scoped=true"
import script from "./HasVideoEmbedIndicator.vue?vue&type=script&lang=js"
export * from "./HasVideoEmbedIndicator.vue?vue&type=script&lang=js"

import "./HasVideoEmbedIndicator.vue?vue&type=style&index=0&id=1dd90b14&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd90b14"]])

export default __exports__